var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 5,
    height: 8,
    viewBox: "0 0 5 8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#303030",
    d: "M55.131,3.051h4.375a.289.289,0,0,0,.22-.1.352.352,0,0,0,0-.477L57.538.1A.29.29,0,0,0,57.1.1L54.911,2.473a.353.353,0,0,0,0,.477A.289.289,0,0,0,55.131,3.051Z",
    transform: "translate(-54.818 0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#303030",
    d: "M59.505,237.549H55.131a.289.289,0,0,0-.22.1.352.352,0,0,0,0,.477L57.1,240.5a.29.29,0,0,0,.439,0l2.187-2.373a.352.352,0,0,0,0-.477A.289.289,0,0,0,59.505,237.549Z",
    transform: "translate(-54.818 -232.6)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.1752f52016e0ee12ba30a7bfd56809dd.svg";
export { ForwardRef as ReactComponent };